/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RequestPasswordResetInput = {
    email: string;
    captchaToken: string;
    clientMutationId?: string | null | undefined;
};
export type AccountRecoveryControllerMutationVariables = {
    input: RequestPasswordResetInput;
};
export type AccountRecoveryControllerMutationResponse = {
    readonly requestPasswordReset: {
        readonly clientMutationId: string | null;
    } | null;
};
export type AccountRecoveryControllerMutation = {
    readonly response: AccountRecoveryControllerMutationResponse;
    readonly variables: AccountRecoveryControllerMutationVariables;
};



/*
mutation AccountRecoveryControllerMutation(
  $input: RequestPasswordResetInput!
) {
  requestPasswordReset(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestPasswordResetPayload",
    "kind": "LinkedField",
    "name": "requestPasswordReset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountRecoveryControllerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountRecoveryControllerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "45ae53ae3625be6b4a18a09441e29385",
    "id": null,
    "metadata": {},
    "name": "AccountRecoveryControllerMutation",
    "operationKind": "mutation",
    "text": "mutation AccountRecoveryControllerMutation(\n  $input: RequestPasswordResetInput!\n) {\n  requestPasswordReset(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b38284194c5986fadcc95e8145d0e86d';
export default node;
